import styled from "styled-components";

export const Title = styled.h2`
   font-size: 36px;
   font-weight: 700;
   line-height: 50px;
   text-align: center;
   color: #2A2637;
   margin-bottom: 48px;
   @media(max-width: 600px) {
     text-align: left;
     width: 200px;
     line-height: 33px;
     margin-bottom: 32px;
  }
`

export const Container = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
   margin-bottom: 52px;
   @media(max-width: 600px) {
     align-items: flex-start ;
   }
   @media(max-width: 1100px) {
     padding: 0 15px;
   }
   @media(max-width: 480px) {
     margin-top: -64px;
  }
`

export const Content = styled.div`
   display: flex;
   justify-content: space-between;
   flex-wrap: wrap;
   width: 1100px;
   margin-bottom: 80px;
   @media(max-width: 1100px) {
     width: 100%;
     align-items: flex-start ;
     margin-bottom: 0;
   }
`

export const ContentBlock = styled.div`
   display: flex;
   justify-content: space-between;
   flex-wrap: wrap;
   width: 1087px;
   margin-bottom: 80px;
   @media(max-width: 1100px) {
     width: 100%;
     align-items: flex-start ;
     margin-bottom: 0px;
   }
`

export const Image = styled.img`
   width: 545px;
   height: 426px;
   margin-right: 64px;
   @media(max-width: 600px) {
     width: 272px;
     height: 213px;
   }
   @media(max-width: 768px) {
     margin-bottom: 20px;
   }
`

export const Image2 = styled.img`
   width: 444px;
   height: 250px;
   margin-bottom: 24px;
   @media(max-width: 1100px) {
     margin-bottom: 20px;
   }
   @media(max-width: 600px) {
    width: 312px;
    height: 175px;
   }   
`

export const Image3 = styled.img`
   width: 476px;
   height: 250px;
   margin-bottom: 24px;
   @media(max-width: 1100px) {
     margin-bottom: 20px;
   }
   @media(max-width: 600px) {
    width: 312px;
    height: 163px;
   }  
`

export const Block = styled.div`
   width: 518px;
`

export const Block2 = styled.div`
   width: 510px;
`

export const TitleText = styled.div`
  font-size: 28px;
  font-weight: 700;
  line-height: 39px;
  color: #2A2637;
  width: 300px;
  margin-bottom: 24px;
  @media(max-width: 1100px) {
     margin-top: 32px;
  }
  @media(max-width: 768px) {
     display: none;
  }
`

export const TitleTextBlock = styled.div`
  font-size: 28px;
  font-weight: 700;
  line-height: 39px;
  color: #2A2637;
  width: 300px;
  margin-bottom: 24px;
  @media(max-width: 1100px) {
     margin-top: 32px;
  }
  @media(max-width: 768px) {
     font-weight: 700;
     line-height: 39px;
     color: #2A2637;   
     margin-bottom: 16px;
     font-size: 20px;
  }
`

export const TitleTextMobile = styled.div`
  display: none;
  @media(max-width: 768px) {
     display: block;
     font-weight: 700;
     line-height: 39px;
     color: #2A2637;   
     margin-bottom: 16px;
     font-size: 20px;
  }  
`

export const Text = styled.div`
  font-size: 18px;
  width: 469px;
  font-weight: 400;
  line-height: 29px;
  color: #2A2637;
  @media(max-width: 768px) {
     font-size: 14px;
     line-height: 22.4px;
  }
  @media(max-width: 515px) {
     width: 312px;
  }
`

export const List = styled.ul`
  list-style: none;
  padding-left: 0;
  width: 491px;
`;

export const TextList = styled.li`
  font-size: 18px;
  font-weight: 400;
  line-height: 31px;
  color: #2A2637;
  margin-bottom: 4px;
  &:before {
      content: '-';
      margin-right: 5px; 
    }
  @media(max-width: 768px) {
     font-size: 14px;
     line-height: 22.4px;
  }
  @media(max-width: 515px) {
     width: 312px;
  }
`

export const Btn = styled.div`
  margin-top: 16px;
`
